import React from "react";
import UserIcon from "../icons/user.png";

const UserMenu = ({
  currentUserAvatar,
  handleLogout,
  loggedIn,
  openModal,
  setShowMenu,
  setShowSearch,
  setModal,
  showMenu,
}) => {
  const handleMenuClick = () => {
    setShowMenu(true);
    setShowSearch(false);
  };

  const handleSwitch = () => {
    setShowMenu(false);
    openModal();
  };

  const handleLogin = () => {
    setModal("login");
    handleSwitch();
  };

  const handleShare = () => {
    setModal("upload");
    handleSwitch();
  };

  const handleProfile = () => {
    setModal("profile");
    handleSwitch();
  };

  return (
    <>
      <button className="profile-icon-container" onClick={handleMenuClick}>
        <img
          className="profile-btn"
          src={currentUserAvatar !== null ? currentUserAvatar : UserIcon}
          alt="user-icon"
        />
      </button>
      {showMenu && (
        <div id="menu">
          <ul id="popup">
            {!loggedIn ? (
              <li>
                <button className="user-menu-selector" onClick={handleLogin}>
                  Login
                </button>
              </li>
            ) : (
              <>
                <li>
                  <button className="user-menu-selector" onClick={handleShare}>
                    Add Cat
                  </button>
                </li>
                <hr></hr>
                <li>
                  <button
                    className="user-menu-selector"
                    onClick={handleProfile}
                  >
                    Profile
                  </button>
                </li>
                <hr></hr>
                <li>
                  <button className="user-menu-selector" onClick={handleLogout}>
                    Logout
                  </button>
                </li>
              </>
            )}
          </ul>
        </div>
      )}
    </>
  );
};

export default UserMenu;
